import React from "react";
import PropertyCalendarHeader from "./PropertyCalendarHeader";
import PropertyCalendarSidebar from "./PropertyCalendarSidebar";
import PropertyCalendarDateGrid from "./PropertyCalendarDateGrid";
import PropertyCalendarToggles from "./PropertyCalendarToggles";

class PropertyCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show_notes: localStorage.getItem('show_notes') != 'false',
      show_notifications: localStorage.getItem('show_notifications') != 'false',
      show_service_logs: localStorage.getItem('show_service_logs') != 'false',
      show_housekeeping: localStorage.getItem('show_housekeeping') != 'false',
      isHousekeeping: this.props.isHousekeeping || false
    }
    this.onChangeToggle = this.onChangeToggle.bind(this);
  }

  componentDidMount() {
    var $PropertyCalendar = $(this.refs.PropertyCalendar);

    $PropertyCalendar.on("scroll", function () {
      var scrollLeft = $PropertyCalendar.scrollLeft();
      var scrollTop = $PropertyCalendar.scrollTop();

      // position sticky divs
      $PropertyCalendar.find(".PropertyCalendarHeader").css({ top: scrollTop });
      $PropertyCalendar
        .find(".PropertyCalendarHeaderCover")
        .css({ top: scrollTop, left: scrollLeft });
      $PropertyCalendar
        .find(".PropertyCalendarSidebar")
        .css({ left: scrollLeft });

      // hide any open tooltips
      $PropertyCalendar.find(".tooltip").tooltip("hide");
    });
  }

  render() {
    return (
      <div
        className={"PropertyCalendar " + (this.props.view_mode || "weekly")}
        ref="PropertyCalendar"
      >
        <div className="PropertyCalendarHeaderCover">{this.props.view_mode == "weekly" && this.props.isHousekeeping == false ? <PropertyCalendarToggles {...this.state} onChangeToggle={this.onChangeToggle} /> : null}</div>
        <PropertyCalendarHeader {...this.props} {...this.state} />
        <PropertyCalendarSidebar {...this.props} {...this.state} />
        <PropertyCalendarDateGrid {...this.props} {...this.state} />
      </div>
    );
  }

  onChangeToggle(e) {
    this.setState({ [e.target.name]: e.target.checked })
    localStorage.setItem(e.target.name, e.target.checked)
  }
}

export default PropertyCalendar;
